import apiAuthClientCalculator from '@/services/apiAuthClientCalculator';
import errorHandler from '@/utilities/serverErrorHandler';

export const actions = {
  getCalculatorProjectList ({ commit, dispatch, getters, rootGetters }) {
      dispatch('ui/updateInterstitial', { isLoading: true, message: 'Getting your application...' }, { root: true });
      return apiAuthClientCalculator.get(`get-project-history`, rootGetters['auth/getAccessToken']).then((res) => {
        if (res.status === 200) {
            commit('UPDATE_CALCULATOR', res.data);
            return true;
        }
      }).catch((err) => {
        return errorHandler('eoiErrors', err);
      }).finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
  },
  createCalculation ({ commit, getters, rootGetters, dispatch }, formData) {
    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Creating your Calculation...' }, { root: true });

    const endpointMap = {
        1: 'new-generation',
        2: 'energy-displacement',
        3: 'energy-displacement-new-generation'
    };
    const endpoint = endpointMap[parseInt(formData.calculationType)] || 'new-generation';

    const payload = {
        companyName: formData.companyName,
        projectName: formData.projectName,
        calculationType: formData.calculationType,
        note: formData.note,
        ...(formData.annualGenerationKwh  && { annualGenerationKwh: formData.annualGenerationKwh }),
        ...(formData.baselineKwh          && { baselineKwh: formData.baselineKwh }),
        ...(formData.postProjectKwh       && { postProjectKwh: formData.postProjectKwh }),
        ...(formData.emissionFactorYear1  && { emissionFactorYear1: formData.emissionFactorYear1 }),
    };

    return apiAuthClientCalculator
    .post(endpoint, payload, rootGetters['auth/getAccessToken'])
    .then((res) => {
        if (res.status === 200) {
            commit('UPDATE_CALCULATION_RESULT', {
                result: res.data,
                calculationType: formData.calculationType,
                projectName: formData.projectName,
            });

            return res.data;
        }
    })
    .catch((err) => {
        return errorHandler('eoiErrors', err);
    })
    .finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  getCalculationById ({ commit, rootGetters, dispatch }, { id, calculationType }) {
    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Loading calculation...' }, { root: true });
    return apiAuthClientCalculator
    .get(`get-project-history-details?projectId=${id}`, rootGetters['auth/getAccessToken'])
    .then((res) => {
        if (res.status === 200) {
            const data = {
                result: res.data,
                calculationType,
            };
            commit('UPDATE_CALCULATION_RESULT', data);
            return data;
        }
    })
    .catch((err) => {
        return errorHandler('eoiErrors', err);
    })
    .finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
},
};
